import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Link, useHistory, useParams } from 'react-router-dom'
// import { ChromePicker } from 'react-color'
import Swal from 'sweetalert2'
import BreadCrumb from 'components/BreadCrumb'
import DefaultButton from 'components/DefaultButton'
import DefaultCreationForm, {
	DefaultCreationFormButtonGroup,
	DefaultCreationFormGroup,
} from 'components/DefaultCreationForm'
import DefaultInput from 'components/DefaultInput'
import { DefaultPageTitle } from 'components/DefaultPageTitle'
import DefaultTextArea from 'components/DefaultTextArea'
import {
	ContentThumbnail,
	CreateAndEditProductContainer,
	ContentUploadOrSelectContainer,
	ButtonGroupInline,
	ThumbnailUploadContainer,
	// ProductColor,
} from './style'
import SelectSambaVideosContent from 'components/SelectSambaVideosContent'
import CutImage from 'components/CutImage'
import checkEmptyString from 'helpers/check-empty-string'
import { createProduct, getProduct, updateProduct } from 'services/products'
import { PRODUCTS } from 'components/Routes/Constants'
import { MediaFromResponse } from 'models/from-api-response/media'

import { uploadFile } from 'services/files'
import showErrorMessage from 'helpers/show-error-message'
import Select from 'react-select'
import ModalContext from 'contexts/ModalContext'

interface CreateAndEditProductProps {
	productId: string
}

const CreateAndEditProduct: React.FC = () => {
	const { productId } = useParams<CreateAndEditProductProps>()

	const history = useHistory()
	const [title, setTitle] = useState('')
	const [subtitle, setSubtitle] = useState('')
	const [description, setDescription] = useState('')
	const [videoReference, setVideoReference] = useState('')
	const [infoUsageRecomendations, setInfoUsageRecomendations] = useState<any>('')
	const [infoConservationCare, setConservationCare] = useState<any>('')
	const [alerts, setAlerts] = useState('')
	const [drugLeaflet, setDrugLeaflet] = useState<any>()
	const [linkSpecialist, setLinkSpecialist] = useState<any>()
	const [presentation, setPresentation] = useState<any>()
	const [activePrinciple, setActivePrinciple] = useState<any>()
	const [NutricionalInformationFileToUpload, setNutricionalInformationFileToUpload] = useState<File>()
	const [NutricionalInformation, setNutricionalInformation] = useState<any>()
	const [ThumbnailFileToUpload, setThumbnailFileToUpload] = useState<File>()
	const [thumbnail, setThumbnail] = useState<any>()
	const [color, setColor] = useState('#000000')
	const [type, setType] = useState('medicine' as 'supplement' | 'medicine')
	const { openModal, hideModal } = useContext(ModalContext)
	const fileInput = useRef<HTMLInputElement>(null)

	const onSelectContent = (sambaVideosContent: MediaFromResponse) => {
		if (sambaVideosContent) {
			if (sambaVideosContent.files && sambaVideosContent.files.length) {
				const firstFile = sambaVideosContent.files[0]

				if (firstFile) {
					const referenceUrl = `${process.env.REACT_APP_PLAYER_INITIAL_URL}/?video=${sambaVideosContent.id}`

					setVideoReference(referenceUrl)
				}
			}
		}

		hideModal()
	}

	const sendContent = () => {
		fileInput?.current?.click()
	}
	const uploadDrugLeaflet = async () => {
		const file = (fileInput?.current?.files || [])[0]
		if (file) {
			const formData = new FormData()
			formData.append('file', file)
			const { reference } = await uploadFile(formData)
			setDrugLeaflet(reference)
		}
	}

	const uploadNutricionalInformation = async (NutricionalInformationFile: any) => {
		const formData = new FormData()
		formData.append('file', NutricionalInformationFile)
		const uploadedFile = await uploadFile(formData)
		return uploadedFile
	}

	const uploadFileThumb = async (ThumbnailFile: any) => {
		const formData = new FormData()
		formData.append('file', ThumbnailFile)
		const uploadedFile = await uploadFile(formData)
		return uploadedFile
	}

	const createContent = async (event: React.FormEvent) => {
		event.preventDefault()

		try {
			if (type === 'medicine') {
				if (checkEmptyString(title)) {
					throw new Error('Informe um título válido para o produto')
				}

				if (checkEmptyString(presentation)) {
					throw new Error('Informe uma apresentação para o medicamento')
				}
				if (checkEmptyString(activePrinciple)) {
					throw new Error('Informe um princípio ativo para o medicamento.')
				}
			}

			if (type === 'supplement') {
				if (checkEmptyString(title)) {
					throw new Error('Informe um título válido para o produto')
				}
				if (checkEmptyString(presentation)) {
					throw new Error('Informe uma apresentação para o medicamento')
				}
				if (checkEmptyString(infoConservationCare)) {
					throw new Error('Informe os cuidados de conservação do seu produto')
				}
			}

			if (linkSpecialist && !checkEmptyString(linkSpecialist)) {
				if (!['http', 'https'].includes(linkSpecialist.split('://')[0])) {
					throw new Error('Insira um link válido (iniciando com http:// ou https://)')
				}
			}

			let FileThumb

			if (ThumbnailFileToUpload) {
				try {
					FileThumb = await uploadFileThumb(ThumbnailFileToUpload)
				} catch (error) {
					throw new Error(
						'Erro ao fazer upload da imagem. Certifique-se de que a imagem selecionada não ultrapasse os 5MB e se a proporção recomendada para upload está correta.'
					)
				}
			}

			let FileNutricionalInformation

			if (NutricionalInformationFileToUpload) {
				try {
					FileNutricionalInformation = await uploadNutricionalInformation(NutricionalInformationFileToUpload)
				} catch (error) {
					throw new Error(
						'Erro ao fazer upload da imagem. Certifique-se de que a imagem selecionada não ultrapasse os 5MB e se a proporção recomendada para upload está correta.'
					)
				}
			}

			await createProduct({
				title,
				subtitle: subtitle || undefined,
				description: description || undefined,
				video_reference: videoReference || undefined,
				thumbnail: FileThumb ? FileThumb.reference : undefined,
				info: {
					usage_recomendations: infoUsageRecomendations || undefined,
					conservation_care: infoConservationCare || undefined,
					color: color,
					nutritional_information: FileNutricionalInformation
						? FileNutricionalInformation.reference
						: undefined,
					presentation: presentation || undefined,
					active_principle: activePrinciple || undefined,
					specialist_link: linkSpecialist || undefined,
					drug_leaflet: drugLeaflet || undefined,
				},
				alerts: alerts || undefined,
				type,
			})

			Swal.fire({
				title: 'Sucesso!',
				text: 'Produto criado com sucesso!',
				icon: 'success',
			})

			goToProducts()
		} catch (error) {
			showErrorMessage(error)
		}
	}

	const updateContent = async (event: React.FormEvent) => {
		event.preventDefault()

		try {
			if (type === 'medicine') {
				if (checkEmptyString(title)) {
					throw new Error('Informe um título válido para o produto')
				}

				if (checkEmptyString(presentation)) {
					throw new Error('Informe uma apresentação para o medicamento')
				}
				if (checkEmptyString(activePrinciple)) {
					throw new Error('Informe um princípio ativo para o medicamento.')
				}
			}

			if (type === 'supplement') {
				if (checkEmptyString(title)) {
					throw new Error('Informe um título válido para o produto')
				}
				if (checkEmptyString(presentation)) {
					throw new Error('Informe uma apresentação para o medicamento')
				}
				if (checkEmptyString(infoConservationCare)) {
					throw new Error('Informe os cuidados de conservação do seu produto')
				}
			}

			if (linkSpecialist && !checkEmptyString(linkSpecialist)) {
				if (!['http', 'https'].includes(linkSpecialist.split('://')[0])) {
					throw new Error('Insira um link válido (iniciando com http:// ou https://)')
				}
			}

			let FileThumb

			if (ThumbnailFileToUpload) {
				try {
					FileThumb = await uploadFileThumb(ThumbnailFileToUpload)
				} catch (error) {
					throw new Error(
						'Erro ao fazer upload da imagem. Certifique-se de que a imagem selecionada não ultrapasse os 5MB e se a proporção recomendada para upload está correta.'
					)
				}
			}

			let FileNutricionalInformation

			if (NutricionalInformationFileToUpload) {
				try {
					FileNutricionalInformation = await uploadNutricionalInformation(NutricionalInformationFileToUpload)
				} catch (error) {
					throw new Error(
						'Erro ao fazer upload da imagem. Certifique-se de que a imagem selecionada não ultrapasse os 5MB e se a proporção recomendada para upload está correta.'
					)
				}
			}

			await updateProduct(productId, {
				title,
				subtitle: subtitle || undefined,
				description: description || undefined,
				video_reference: videoReference || undefined,
				thumbnail: FileThumb ? FileThumb.reference : undefined,
				info: {
					usage_recomendations: infoUsageRecomendations,
					conservation_care: infoConservationCare,
					color: color,
					nutritional_information: FileNutricionalInformation
						? FileNutricionalInformation.reference
						: undefined,
					presentation: presentation || undefined,
					active_principle: activePrinciple || undefined,
					specialist_link: linkSpecialist || undefined,
					drug_leaflet: drugLeaflet || undefined,
				},
				alerts: alerts || undefined,
				type,
			})

			Swal.fire({
				title: 'Sucesso!',
				text: 'Produto atualizado com sucesso!',
				icon: 'success',
			})

			goToProducts()
		} catch (error) {
			showErrorMessage(error)
		}
	}

	const selectThumbnail = () => {
		openModal(
			'Selecionar a Imagem do Produto',
			<CutImage aspect={type === 'supplement' ? 0.6135 : 0} onCutImage={onCutImage} />
		)
	}

	const onCutImage = (file: File) => {
		if (file) {
			setThumbnailFileToUpload(file)
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => setThumbnail(`${reader.result}`)
			hideModal()
		}
	}

	const selectNutricionalInformation = () => {
		openModal(
			'Selecionar a Imagem de uma tabela nutricional do produto',
			<CutImage aspect={1175 / 458} onCutImage={onCutImageNutricionalInformation} />
		)
	}

	const onCutImageNutricionalInformation = (file: File) => {
		if (file) {
			setNutricionalInformationFileToUpload(file)
			const reader = new FileReader()
			reader.readAsDataURL(file)
			reader.onload = () => setNutricionalInformation(`${reader.result}`)
			hideModal()
		}
	}

	const goToProducts = () => {
		history.push(`${PRODUCTS}`)
	}

	const getContent = useCallback(async () => {
		if (productId) {
			const product = await getProduct(productId)
			if (product && Object.keys(product).length) {
				setTitle(product.title)
				setSubtitle(product.subtitle)
				setThumbnail(product.thumbnail)
				setVideoReference(product.video_reference)
				setDescription(product.description)
				setColor(product.info.color || '#000000')
				setConservationCare(product.info.conservation_care)
				setInfoUsageRecomendations(product.info.usage_recomendations)
				setAlerts(product.alerts)
				setNutricionalInformation(product.info.nutritional_information)
				setType(product.type as 'supplement' | 'medicine')
				setLinkSpecialist(product?.info?.specialist_link)
				setPresentation(product?.info?.presentation)
				setActivePrinciple(product?.info?.active_principle)
				setDrugLeaflet(product?.info?.drug_leaflet)
			}
		}
	}, [productId])

	useEffect(() => {
		getContent()
	}, [getContent])

	const isEditting = useMemo(() => !!productId, [productId])

	const selectContent = () => {
		openModal('Selecionar Conteúdo', <SelectSambaVideosContent onSelectContent={onSelectContent} />)
	}

	return (
		<CreateAndEditProductContainer>
			<BreadCrumb
				crumbs={[
					<Link to={`${PRODUCTS}`}>Produtos</Link>,
					<span>{isEditting ? 'Editar' : 'Criar'} Produto</span>,
				]}
			/>

			<DefaultPageTitle>{isEditting ? 'Editar' : 'Criar'} Produto</DefaultPageTitle>

			<DefaultCreationForm>
				<DefaultCreationFormGroup>
					<label htmlFor="type">Tipo</label>

					<Select
						styles={{ container: (base) => ({ ...base, width: '100%' }) }}
						onChange={(option) => {
							option && setType(option.value as 'medicine' | 'supplement')
						}}
						options={[
							{ value: 'medicine', label: 'Medicamento' },
							{ value: 'supplement', label: 'Suplemento' },
						]}
						value={{ value: type, label: type === 'supplement' ? 'Suplemento' : 'Medicamento' }}
					/>
				</DefaultCreationFormGroup>

				<DefaultCreationFormGroup>
					<label className="required" htmlFor="title">
						Nome do produto
					</label>
					<DefaultInput value={title} onChange={(e) => setTitle(e.target.value)} id="title" required />
				</DefaultCreationFormGroup>

				{type === 'supplement' && (
					<DefaultCreationFormGroup>
						<label htmlFor="subtitle">Subtitulo do produto</label>
						<DefaultInput
							value={subtitle}
							onChange={(e) => setSubtitle(e.target.value)}
							id="subtitle"
							required
						/>
					</DefaultCreationFormGroup>
				)}

				<DefaultCreationFormGroup>
					<label htmlFor="description">Descrição</label>
					<DefaultTextArea
						value={description}
						onChange={(e) => setDescription(e.target.value)}
						id="description"
						required
					/>
				</DefaultCreationFormGroup>

				{type === 'medicine' && (
					<>
						<DefaultCreationFormGroup>
							<label htmlFor="presentation" className="required">
								Apresentação
							</label>
							<DefaultTextArea
								value={presentation}
								onChange={(e) => setPresentation(e.target.value)}
								id="presentation"
								required
							/>
						</DefaultCreationFormGroup>
						<DefaultCreationFormGroup>
							<label htmlFor="activePrinciple" className="required">
								Princípio Ativo
							</label>
							<DefaultInput
								value={activePrinciple}
								onChange={(e) => setActivePrinciple(e.target.value)}
								id="activePrinciple"
								required
							/>
						</DefaultCreationFormGroup>

						<DefaultCreationFormGroup>
							<label htmlFor="url">Link Especialista</label>
							<DefaultInput
								type="url"
								id="url"
								placeholder="http://"
								value={linkSpecialist}
								onChange={(e) => setLinkSpecialist(e.target.value)}
							/>
						</DefaultCreationFormGroup>
						<DefaultCreationFormGroup>
							<label htmlFor="description">Bula</label>
							{(fileInput?.current?.files || []).length > 0 && (
								<span>
									<strong>Arquivo: </strong> {(fileInput?.current?.files || [])[0]?.name}
								</span>
							)}
							<DefaultButton type="button" onClick={sendContent}>
								Enviar Conteúdo
							</DefaultButton>
							<input
								ref={fileInput}
								type="file"
								style={{ display: 'none' }}
								onChange={uploadDrugLeaflet}
							/>
						</DefaultCreationFormGroup>
					</>
				)}
				{type === 'supplement' && (
					<>
						<DefaultCreationFormGroup>
							<label htmlFor="conservation_care">Recomendações de uso</label>
							<DefaultTextArea
								value={infoUsageRecomendations}
								onChange={(e) => setInfoUsageRecomendations(e.target.value)}
								id="usage_recomendations"
								required
							/>
						</DefaultCreationFormGroup>

						<DefaultCreationFormGroup>
							<label htmlFor="presentation" className="required">
								Apresentação
							</label>
							<DefaultTextArea
								value={presentation}
								onChange={(e) => setPresentation(e.target.value)}
								id="presentation"
								required
							/>
						</DefaultCreationFormGroup>

						<DefaultCreationFormGroup>
							<label htmlFor="usage_recomendations" className="required">
								Cuidados de conservação
							</label>
							<DefaultTextArea
								value={infoConservationCare}
								onChange={(e) => setConservationCare(e.target.value)}
								id="conservation_care"
								required
							/>
						</DefaultCreationFormGroup>

						<DefaultCreationFormGroup>
							<label htmlFor="alerts">Informações importantes</label>
							<DefaultTextArea
								value={alerts}
								onChange={(e) => setAlerts(e.target.value)}
								id="alerts"
								required
							/>
						</DefaultCreationFormGroup>

						<DefaultCreationFormGroup>
							<label htmlFor="reference">Imagem da tabela nutricional do produto</label>
							<p style={{ marginBottom: '10px', color: '#8898aa' }}>
								Largura máxima de 1175px e altura máxima de 458px{' '}
							</p>
							<ThumbnailUploadContainer>
								<DefaultButton type="button" onClick={selectNutricionalInformation}>
									Selecionar Imagem
								</DefaultButton>
								{NutricionalInformation && <ContentThumbnail src={NutricionalInformation} />}
							</ThumbnailUploadContainer>
						</DefaultCreationFormGroup>

						<DefaultCreationFormGroup>
							<label htmlFor="url">Link Especialista</label>

							<DefaultInput
								type="url"
								id="url"
								placeholder="http://"
								value={linkSpecialist}
								onChange={(e) => setLinkSpecialist(e.target.value)}
							/>
						</DefaultCreationFormGroup>
					</>
				)}

				<DefaultCreationFormGroup>
					<label className="required" htmlFor="reference">
						Imagem do produto
					</label>
					<span className="observation-img">
						{type === 'supplement' ? <li>Recomendado: 690×435</li> : <li>Recomendado: 400×255</li>}
					</span>
					<ThumbnailUploadContainer>
						<DefaultButton type="button" onClick={selectThumbnail}>
							Selecionar Imagem do Produto
						</DefaultButton>
						{thumbnail && <ContentThumbnail src={thumbnail} />}
					</ThumbnailUploadContainer>
				</DefaultCreationFormGroup>

				{/*<DefaultCreationFormGroup>
					<label htmlFor="videoReference">Vídeo do produto</label>

					<ContentUploadOrSelectContainer>
						<ButtonGroupInline>
							<DefaultButton type="button" onClick={selectContent}>
								Selecionar Conteúdo
							</DefaultButton>
						</ButtonGroupInline>
						{videoReference ? (
							<iframe
								title="referenced-video"
								allowFullScreen
								src={videoReference}
								frameBorder={0}
							></iframe>
						) : (
							<></>
						)}
					</ContentUploadOrSelectContainer>
						</DefaultCreationFormGroup>*/}

				{/* <DefaultCreationFormGroup>
					<label className="required">Cor do banner do título do produto</label>
					<ProductColor color={color} />
					<div className="color-picker-container">
						<ChromePicker
							color={color}
							onChangeComplete={(color) => setColor(color.hex)}
							disableAlpha={true}
						/>
					</div>
				</DefaultCreationFormGroup> */}

				<DefaultCreationFormButtonGroup>
					<DefaultButton type="button" className="danger" onClick={goToProducts}>
						Cancelar
					</DefaultButton>
					<DefaultButton
						onClick={(e) => (isEditting ? updateContent(e) : createContent(e))}
						className="success"
					>
						Salvar
					</DefaultButton>
				</DefaultCreationFormButtonGroup>
			</DefaultCreationForm>
		</CreateAndEditProductContainer>
	)
}

export default CreateAndEditProduct
